export enum RolePermission {
  AddCustomer = 21,
  EditCustomer = 22,
  AddJob = 9,
  EditJob = 10,
  AddLead = 12,
  EditLead = 13,
  AddQuote = 6,
  EditQuote = 7,
  SalesPerson = 25,
  FieldTechnician = 26,
  Salesperson_NonBIDIT = 27,
  Admin = 28,
  ShowLineItemPricing = 29,
  ShowCostBreakdown = 30,
  ViewEditMargins = 31,
  AddChangeOrder = 32,
  EditChangeOrder = 33,
  BidLog = 34,
  QuotesLeadsSource = 35,
  LostQuoteAnalysis = 36,
  CustQuoteContract = 37,
  JobCost = 38,
  PayrollSummary = 39,
  EmailLog = 40,
  SMSLog = 41,
  Inventory = 42,
  QuoteAnalysis = 43,
  AddWorkOrder = 44,
  EditWorkOrder = 45
}
